import { render, staticRenderFns } from "./ProductEditComposition.vue?vue&type=template&id=7073899c&scoped=true"
import script from "./ProductEditComposition.vue?vue&type=script&lang=ts"
export * from "./ProductEditComposition.vue?vue&type=script&lang=ts"
import style0 from "./ProductEditComposition.vue?vue&type=style&index=0&id=7073899c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7073899c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7073899c')) {
      api.createRecord('7073899c', component.options)
    } else {
      api.reload('7073899c', component.options)
    }
    module.hot.accept("./ProductEditComposition.vue?vue&type=template&id=7073899c&scoped=true", function () {
      api.rerender('7073899c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductEditComposition.vue"
export default component.exports